import * as React from 'react';

import Direccion, {
    Datos as DireccionDatos,
    inicial as direccionInicial,
} from './componentes/Direccion';

export interface Datos {
    particular: DireccionDatos;
    laboral: DireccionDatos;
}

export const inicial: Datos = {
    particular: { ...direccionInicial },
    laboral: { ...direccionInicial },
};

interface Props {
    direcciones: Datos;
    requeridos?: boolean;
    onChange(direcciones: Datos): void;
}

class Direcciones extends React.PureComponent<Props> {
    public render() {
        const { direcciones, requeridos = false } = this.props;

        return (
            <div>
                <Direccion
                    titulo='Dirección particular'
                    direccion={direcciones.particular}
                    onChange={this.manejarCambioDireccionParticular}
                    requeridos={requeridos}
                />
                <Direccion
                    titulo='Dirección laboral'
                    direccion={direcciones.laboral}
                    onChange={this.manejarCambioDireccionLaboral}
                />
            </div>
        );
    }

    private readonly manejarCambioDireccionParticular = (particular: DireccionDatos) => {
        this.props.onChange({
            ...this.props.direcciones,
            particular,
        });
    };

    private readonly manejarCambioDireccionLaboral = (laboral: DireccionDatos) => {
        this.props.onChange({
            ...this.props.direcciones,
            laboral,
        });
    };
}

export default Direcciones;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/Direcciones/index.tsx